import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, Typography, Paper, Stack, IconButton } from "@mui/material";
import JsonView from "@uiw/react-json-view";

import { useAppSelector } from "~/app/store";
import { selectUsersFulfillmentCenter } from "~/redux/selectors/storeSelectors";

function copyJsonToClipboard(data: unknown) {
  if (!data) return;
  const jsonString = JSON.stringify(data, null, 2);

  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(jsonString).catch(() => {
      // do nothing
    });
  }
}

export const FcConfigList = () => {
  const usersFulfillmentCenter = useAppSelector(selectUsersFulfillmentCenter);

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, maxWidth: 800 }} elevation={2}>
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <Typography variant="h6" sx={{ mb: 0 }}>
            Fulfillment Center Configuration
          </Typography>
          {usersFulfillmentCenter && (
            <IconButton
              aria-label="Copy fulfillment center configuration"
              size="small"
              onClick={() => copyJsonToClipboard(usersFulfillmentCenter)}
            >
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          )}
        </Stack>
        {usersFulfillmentCenter ? (
          <div
            role="region"
            aria-label="Fulfillment center configuration details"
          >
            <JsonView
              value={usersFulfillmentCenter}
              displayDataTypes={false}
              indentWidth={4}
              enableClipboard={false}
              style={{
                fontSize: 16
              }}
              collapsed={1}
            />
          </div>
        ) : (
          <Typography color="text.secondary">
            No configuration available.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};
